import React, { useEffect, useRef, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../../CustomComponents/FieldInput";
import FieldArea from "../../../../CustomComponents/FieldText";
import ReactSelect from "react-select";
import axiosInstance from "../../../../../redux/api";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { getUmbrallyProjectList } from "../../../../../redux/project/action";
import { Tooltip } from "react-tooltip";
import LoginLoaderButton from "../../../../Common/Loader/LoginLoaderButton";
import CustomReactQuill from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuill";
import {
  getCategary,
  getIndustry,
  getSubcategary,
  getWithParentCategary,
} from "../../../../../redux/categary/action";
import { descriptionvalidation, titlevalidation } from "../../../../Common/commonvalidation";
import AsteriskLabel from "../../../../Common/AsteriskLabel";
import ChoosePostType from "../../../../Common/ChoosePostType";
import { umbrellaprojecttips } from "../../../../Common/Tooltips/tooltip";
import CommonIndustryOption from "../../../../Common/CommonIndustryOption";
import useEnterKeySubmit from "../../../../../utils/useEnterKeySubmit";
import CommissionNote from "../../../../Common/ImportantNote/CommissionNote";

const formdatatomap = [
  { title: (<>Select a service type <AsteriskLabel /></>), name: "type", placeholder: "Choose post type" },
  { title: "This is an umbrella project", name: "is_ambrella", placeholder: "This is an umbrella project", },
  { title: (<>Write a title for your post <AsteriskLabel /></>), name: "title", placeholder: "Enter Title", },
  { title: (<>Select Industries <AsteriskLabel /></>), name: "industry_id", placeholder: "Select An Option", },
  { title: (<>Select Category <AsteriskLabel /></>), name: "category_id", placeholder: "Select An Option", },
  { title: (<>Project Description <AsteriskLabel /></>), name: "description", placeholder: "Enter detailed project description", },
];

const PAboutProject = ({ formData, setFormData, nextPage }) => {
  const [loading, setLoading] = useState(false);
  const [ambrella, setAmbrella] = useState(formData?.is_ambrella || 0);
  const [showep, setShowep] = useState(formData?.ambrella_title ? true : false);
  const [parentid, setParentid] = useState(formData?.category_id || "");
  const [category, setCategory] = useState([]);
  const [subcategory, setSubcategory] = useState([]);
  const [industrySelected, setIndustrySelected] = useState(formData?.industry_id || "");

 const [selectexisingprojects, setselectExisingprojects] = useState(
  formData.exisingprojects_index || []
);
  const [selectCatgory, setselectCatgory] = useState(
    formData.category_index || []
  );
  const [selectSubcategory, setSelectSubcategory] = useState(
    formData.subcategory_index || []
  );
  const formikRef = useRef(null);

  const validationSchema = Yup.object().shape({
    type: Yup.string().required("Post type is required"),
    title: titlevalidation,
    description: descriptionvalidation,
    category_id: Yup.string().required("Category is required"),
    industry_id: Yup.string().required("Industry is required"),
    is_ambrella: Yup.string(),
    parent_id:
      ambrella == 1 && showep == false
        ? Yup.string()
          .required("This is required")
          .test(
            "not-only-spaces",
            "Please enter a valid value",
            (value) => value.trim() !== ""
          )
        : "",
    ambrella_title:
      ambrella == 1 && showep == true
        ? Yup.string()
          .required("This is required")
          .test(
            "not-only-spaces",
            "Please enter a valid value",
            (value) => value.trim() !== ""
          )
        : "",
  });

  const initialValues = {
    type: formData?.type,
    is_ambrella: formData?.is_ambrella == 1 ? 1 : 0,
    ambrella_title: formData?.ambrella_title,
    parent_id: formData?.is_ambrella === 1 ? parseInt(formData?.parent_id) : "",
    title: formData?.title,
    industry_id: formData?.industry_id,
    category_id: formData?.category_id,
    sub_category_id: formData?.sub_category_id,
    description: formData?.description,
  };

  console.log(initialValues,"initialValuesinitialValues")
  const dispatch = useDispatch();
  // const categarylist = useSelector(
  //   ({ categary: { categarylist } }) => categarylist
  // );
  const getumbrallyprojectlist = useSelector(
    ({ project: { getumbrallyprojectlist } }) => getumbrallyprojectlist
  );
console.log(getumbrallyprojectlist,"getumbrallyprojectlistgetumbrallyprojectlist")

  const TheIndustryList = useSelector(
    ({ categary: { industrylist } }) => industrylist
  );

  useEffect(() => {
    LoadCSSforfirstTime("Assets/scss/FirstTimeUsers.module.scss");
  }, []);

  // useEffect(() => {
  //   setCategory(categarylist);
  // }, [categarylist]);

  useEffect(() => {
    dispatch(getUmbrallyProjectList());
    dispatch(getIndustry());
  }, []);

  useEffect(() => {
    if (industrySelected) {
      dispatch(getWithParentCategary(industrySelected)).then((res) => {
        setCategory(res?.response || []);
      });
    }
  }, [industrySelected]);

  useEffect(() => {
    selectCatgory && dispatch(getSubcategary(selectCatgory.value));
  }, [selectCatgory]);

  // useEffect(() => {
  //   if (parentid) {
  //     axiosInstance
  //       .get(`category?type=3&parent_id=${parentid}`)
  //       .then((response) => {
  //         setSubcategory(response?.data?.response);
  //       });
  //   }
  // }, [parentid]);


  useEffect(() => {
    if (parentid) {
      axiosInstance
        .get(`category?type=3&parent_id=${parentid}`)
        .then((response) => {
          setSubcategory(response?.data?.response);
        });
    }
  }, [parentid]);

 console.log(formData,"formDataformData")
useEffect(() => {
  if (formData?.parent_id && Array.isArray(getumbrallyprojectlist)) {
    const matchedProject = getumbrallyprojectlist.find(
      (p) => String(p.id) === String(formData.parent_id)
    );
      
    if (matchedProject) {
      setselectExisingprojects({
        value: matchedProject.id,
        label: matchedProject.ambrella_title,
      });
    }
  }
}, [getumbrallyprojectlist, formData?.parent_id]);


  const handleSubmit = async (values) => {
    setLoading(true);
    await new Promise((resolve) => setTimeout(resolve, 1000));

    setFormData((prevData) => ({
      ...prevData,
      ...values,
    }));

    nextPage();
    setLoading(false);
  };

  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handlevalues = (formik) => {
    formik.setFieldValue("ambrella_title", "");
    setShowep(false);
  };

  const handlevalues11 = (formik) => {
    setShowep(true);
    setselectExisingprojects([]);
    formik.setFieldValue("parent_id", "");
  };

  useEnterKeySubmit(handleNextClick);

  return (
    <div className="app-container">
      <div className="col-lg-10  col-md-11 mx-auto expert-flow">
        <div className="col-lg-10 mx-auto">
          <div className="row about-row">
            <div className="col-lg-4    about-left">
              <h6>
                01/04<span>Create a post</span>
              </h6>
              <h2>Let’s create your post with a title first</h2>
              <p>Choose a clear and strong title</p>
            </div>
            <div className="col-lg-6   about-right">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                innerRef={formikRef}
                enableReinitialize
              >
                {(formik) => (
                  <Form>
                    {formdatatomap.map((prop, key) => {
                      if (prop.name == "is_ambrella") {
                        return (
                          <React.Fragment key={key}>
      <div className="form-group">
        <div className="checkbox-input umbrella-checkbox">

          {/* 1. Change <Field> to standard <input> */}
         <input
  id={`checkbox-${prop.name}`}
  type="checkbox"
  name={prop.name}
  checked={formik.values[prop.name] == 1} // Ensure this is loose equality or checks for integer
  onChange={(e) => {
    // CHANGE: Use integers 1 and 0 instead of "1" and "0"
    const newValue = e.target.checked ? 1 : 0; 
    
    // 2. Update Formik
    formik.setFieldValue(prop.name, newValue);
    
    // 3. Update Local State
    setAmbrella(newValue);
    
    // 4. CRUCIAL: Sync parent formData to prevent enableReinitialize from reverting it!
    setFormData((prev) => ({ 
      ...prev, 
      [prop.name]: newValue 
    }));
  }}
/>

          <label style={{ marginTop: '8px' }}>
            {prop.placeholder}
          </label>

                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    console.log("Icon clicked only!");
                                  }}
                                  className="icon-click-area"
                                >
                                  <img
                                    data-tooltip-id="my-tooltip-1"
                                    src={`${CloudStorage.cloudurl}/Assets/Images/postjob/post-icon.svg`}
                                    alt=""
                                  />
                                </div>

                              </div>


                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>

                            {formik?.values?.is_ambrella == 1 && (
                              <>
                               {!showep && (
  <div className="form-group ">
    <label>Select Umbrella project <AsteriskLabel /></label>
    
    <ReactSelect
      // 1. Safely handle the options array (prevents passing 'false')
      options={
        Array.isArray(getumbrallyprojectlist)
          ? getumbrallyprojectlist.map((project) => ({
              value: project.id,
              label: project.ambrella_title,
            }))
          : []
      }
      placeholder="Choose existing umbrella projects"
      
      // 2. Bind directly to Formik's state. As soon as the list loads, it finds the match.
      value={
        Array.isArray(getumbrallyprojectlist)
          ? getumbrallyprojectlist
              .map((p) => ({ value: p.id, label: p.ambrella_title }))
              .find((opt) => String(opt.value) === String(formik.values.parent_id)) || null
          : null
      }
      
      noOptionsMessage={() => "No existing umbrella projects"}
      
      // 3. Just update Formik directly
      onChange={(selectedOption) => {
        formik.setFieldValue("parent_id", selectedOption.value);
        formik.setFieldValue("ambrella_title", "");
      }}
    />
    
    <ErrorMessage
      name="parent_id"
      component="div"
      className="error"
    />
  </div>
)}

                                {showep && (
                                  <div className="" key={key}>
                                    <FieldInput
                                      title={<>New Umbrella project <AsteriskLabel /></>}
                                      onChange={(e) => {
                                        setselectExisingprojects([]);
                                        formik.setFieldValue("parent_id", "");
                                        formik.setFieldValue(
                                          "ambrella_title",
                                          e.target.value
                                        );
                                      }}
                                      name="ambrella_title"
                                      placeholder="Enter title for umbrella project"
                                      key={key}
                                    />
                                  </div>
                                )}
                                <p
                                  className="create-existing buttons border-button mt-3"
                                  type="text"
                                  onClick={() => {
                                    showep
                                      ? handlevalues(formik)
                                      : handlevalues11(formik);
                                  }}
                                >
                                  {showep
                                    ? "Select existing Umbrella project"
                                    : "Create new Umbrella project"}
                                </p>
                              </>
                            )}
                          </React.Fragment>
                        );
                      }
                      if (prop.name == "title") {
                        return (
                          <div key={key}>
                            <FieldInput
                              title={prop.title}
                              name={prop.name}
                              placeholder={prop.placeholder}
                            />
                            <div className="title">
                              <h5>Title examples</h5>
                              <p>Create an eye-catching logo</p>
                              <p>
                                Develop a responsive website with payment
                                gateway functionality
                              </p>
                              <p>
                                Convert UI to HTML for an e-commerce website
                                etc.
                              </p>
                            </div>
                          </div>
                        );
                      }
                      if (prop.name == "industry_id") {
                        return (
                          <CommonIndustryOption
                            key={key}
                            options={TheIndustryList}
                            formik={formik}
                            prop={prop}
                            setSelectedIndustry={setIndustrySelected}
                            setSelectCategory={setselectCatgory}
                          />
                        );
                      }

                      if (prop.name == "category_id") {
                        return (
                          <>
                            <div className="row" key={key}>
                              <div className="form-group col-md-6">
                                <label>{prop.title}</label>
                                <ReactSelect
                                  options={
                                    Array.isArray(category) ?
                                    category.map((lang) => ({
                                      value: lang.id,
                                      label: lang.title,
                                    })) : []
                                  }
                                  placeholder={prop.placeholder}
                                  value={selectCatgory}
                                  onChange={(options) => {
                                    setselectCatgory(options);
                                    setParentid(options.value);
                                    setSelectSubcategory("");
                                    formik.setFieldValue(
                                      "category_index",
                                      options
                                    );
                                    formik.setFieldValue(
                                      prop.name,
                                      options.value
                                    );
                                    formik.setFieldValue("subcategory_index", "");
                                    formik.setFieldValue("sub_category_id", "");
                                  }}
                                />
                                <ErrorMessage
                                  name={prop.name}
                                  component="div"
                                  className="error"
                                />
                              </div>
                              <>
                                {
                                  (Array.isArray(subcategory) && subcategory?.length > 0) ?
                                    <>
                                      {formik?.values?.category_id && (
                                        <div className="form-group col-md-6">
                                          <label>Select sub category</label>
                                          <ReactSelect
                                            options={
                                              Array.isArray(subcategory) ?
                                              subcategory.map((lang) => ({
                                                value: lang.id,
                                                label: lang.title,
                                              })) : []
                                            }
                                            placeholder="Select An Option"
                                            noOptionsMessage={() => "No option"}
                                            value={selectSubcategory}
                                            onChange={(options) => {
                                              setSelectSubcategory(options);
                                              formik.setFieldValue(
                                                "sub_category_id",
                                                options.value
                                              );
                                              formik.setFieldValue(
                                                "subcategory_index",
                                                options
                                              );
                                            }}
                                          />
                                          <ErrorMessage
                                            name="sub_category_id"
                                            component="div"
                                            className="error"
                                          />
                                        </div>
                                      )}
                                    </>
                                    : <></>
                                }
                              </>
                            </div>
                          </>
                        );
                      }
                      if (prop.name == "type") {
                        return (
                          <div key={key}>
                            <div className="form-group">
                              <ChoosePostType title={prop.title} />
                              <div className="checkbox-label">
                                <label className="checkbox-container">
                                  <Field
                                    type="radio"
                                    name={prop.name}
                                    checked={formik.values[prop.name] == 1}
                                    value="1"
                                    onChange={handleChange}
                                  />
                                  <span className="checkmark">Post & Browse Projects (PBP)</span>
                                </label>
                                <label className="checkbox-container">
                                  <Field
                                    type="radio"
                                    name={prop.name}
                                    checked={formik.values[prop.name] == 2}
                                    value="2"
                                    onChange={handleChange}
                                  />
                                  <span className="checkmark">Win Business Opportunities (WBO)</span>
                                </label>
                                <label className="checkbox-container">
                                  <Field
                                    type="radio"
                                    name={prop.name}
                                    checked={formik.values[prop.name] == 3}
                                    value="3"
                                    onChange={handleChange}
                                  />
                                  <span className="checkmark">
                                    Part Time Job (PTJ)
                                  </span>
                                </label>
                              </div>
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>
                            <CommissionNote type={'publish_project'} item={"post and browse project"} />
                          </div>
                        );
                      }
                      if (prop.name == "description") {
                        return (
                          <React.Fragment key={key}>
                            <CustomReactQuill
                              value={formik.values.description}
                              formik={formik}
                              name={prop.name}
                              title={prop.title}
                            />
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                              style={{ color: "red" }}
                            />
                          </React.Fragment>
                        );
                      }
                      return (
                        <FieldInput
                          title={prop.title}
                          name={prop.name}
                          placeholder={prop.placeholder}
                          key={key}
                        />
                      );
                    })}
                    <button
                      type="submit"
                      style={{ display: "none" }}
                      ref={formikRef}
                    ></button>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
      <div className="button-container col-lg-8 col-md-11 mx-auto d-flex justify-content-end">
        <button className="next-button" onClick={handleNextClick} type="submit">
          {loading ? (
            <LoginLoaderButton />
          ) : (
            <>
              Next
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/common/right-arrow.svg`}
                alt=""
              />
            </>
          )}
        </button>
      </div>

      <Tooltip
        id="my-tooltip-1"
        place="bottom"
        content={umbrellaprojecttips}
      />
    </div>
  );
};

export default PAboutProject;
